import React, { useCallback, useContext, useState } from 'react';
import styled from 'styled-components';
import { FlexSpace, FormModal, InputField } from '@ubeya/shared-web/components';
import { responsiveFields } from '@ubeya/shared-web/style';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Container = styled(FlexSpace)`
  ${responsiveFields.mobile};
`;

const TotalTimeModal = ({ title, onClose, onConfirm }) => {
  const { t } = useContext(ConfigContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = useCallback(
    (values) => {
      setIsLoading(true);
      const { hours } = values;
      const hoursFormatted = parseFloat(hours);
      if (!Number.isNaN(hoursFormatted)) {
        setTimeout(() => onConfirm({ hours: hoursFormatted }), 800);
      }
    },
    [onConfirm]
  );

  return (
    <FormModal
      initialValues={{}}
      onSubmit={handleSubmit}
      size="small"
      onClose={onClose}
      title={title}
      confirmText={t('save')}
      showCancelButton
      loadingConfirm={isLoading}
      closeOnClickOutside
      isScrollableContent={false}
      disabledOnPristine={false}>
      <Container>
        <InputField autoFocus name="hours" placeholder={t('insert')} />
      </Container>
    </FormModal>
  );
};

export default TotalTimeModal;
